import { useCallback, useEffect, useState } from "react";
import useAlert from "../Alerts/useAlert";
import { BusinessUnit } from "../Types/BusinessUnit";
import { typeCheckResponse } from "./TypeUtils";
import { useHttpUtils } from "./useHttpUtils";

export const useUserAssignedBusinessUnits = () => {
    const { fetchDataAuthenticated } = useHttpUtils();
    const { setAlert } = useAlert();
    const [userAssignedBusinessUnits, setUserAssignedBusinessUnits] = useState<BusinessUnit[]>([]);

    const getBusinessUnits = useCallback(() => {
        fetchDataAuthenticated("api/v1/user/businessUnits", "GET")
            .then(async (response) => {
                if (response.ok) {
                    return response.json();
                }

                throw new Error(await response.json());
            })
            .then((data) => {
                const expectedType: BusinessUnit[] = [];
                if (!typeCheckResponse(data, expectedType)) {
                    throw new Error("Data was not expected type when fetching business units");
                }
                setUserAssignedBusinessUnits(data);
            })
            .catch(error => {
                setAlert("danger", "Error", "Failed to get user assigned business units. " + error.message);
            });
    }, [fetchDataAuthenticated, setAlert]);

    useEffect(() => {
        getBusinessUnits();
    }, [getBusinessUnits]);

    return { userAssignedBusinessUnits }
};